import { render, staticRenderFns } from "./CurrentBankAccount.vue?vue&type=template&id=9eb3cb80&scoped=true"
import script from "./CurrentBankAccount.vue?vue&type=script&lang=js"
export * from "./CurrentBankAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb3cb80",
  null
  
)

export default component.exports